import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './features/auth/Interceptor/auth-interceptor';
import { BrandingService } from './shared/services/branding/branding.service';
import { Title } from '@angular/platform-browser';
import { PermissionService } from './shared/services/permesions/Permesions.service';
import { AuthService } from './core/services/auth-service';

function brandInit(branding: BrandingService, title: Title) {
  return () => {
    // تأكد إن البراند اتحدد من الهوست
    branding.initFromHost();

    // اضبط العنوان أول مرة
    title.setTitle(`${branding.brandName} Front`);

    // ولو البراند اتغيّر (محليًا أثناء التجربة)، حدّث العنوان
    branding.brandStream.subscribe(() => {
      title.setTitle(`${branding.brandName} Front`);
    });
  };
}

function permissionsInit(perms: PermissionService, auth: AuthService) {
  return () => {
    const stored = auth.retrieve('permissions');
    perms.loadFromBackend(Array.isArray(stored) ? stored : []);
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: brandInit,
      deps: [BrandingService, Title],
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: permissionsInit,
      deps: [PermissionService, AuthService],
    },
  ],
};
